import "./Tools.scss";
import "../common.scss";
import star from "../../assets/star-img.png";

export default function Tools() {
  const logos = [
    { id: 1, text: "Development API" },
    { id: 2, text: "Invoices" },
    { id: 3, text: "Fiat payments" },
    { id: 4, text: "Subscriptions" },
    { id: 5, text: "Payment Button" },
    { id: 6, text: "Donation Tools" },
    { id: 7, text: "Point Of Sale" },
    { id: 8, text: "Plug-ins" },
     { id: 9, text: "Payment Widget" },
      { id: 10, text: "White Label" },
       { id: 11, text: "Mass Layouts" },
        { id: 12, text: "Custody" },
         { id: 13, text: "Off-ramp Payouts" },
          { id: 14, text: "Costumer Operations" },
  ];

  return (
    <div className="tools">
      <div className="top spacing">
        <span>Ready When You Are</span>
        <h2>All-in-One Crypto Payment Setup</h2>
        <p>
          Boost revenue, cut processing costs, and stay in control with
          real-time insights in your personal dashboard.
        </p>
        <div className="btn">
          <button onClick={()=>{
            const form =  document.getElementById('form');
                  if(form){
                    form.scrollIntoView({behavior:'smooth'})
                  }
          }} className="btnn">Integrate with Floxy Pay </button>
          <button onClick={() => {window.open('https://forms.gle/7FmYcR7PrDpUbta76', '_blank');}} className="learnmore btnn"> Get Started</button>
        </div>
      </div>
      <div className="bottom">
        <div className="logo-marquee">
          <div className="logo-marquee__container">
            <div className="logo-marquee__content">
              {logos.map((logo) => (
                <>
                  <div key={logo.id} className="logo-marquee__item">
                    <span>{logo.text}</span>
                  </div>
                  <img src={star} alt="error" />
                </>
              ))}

              {logos.map((logo) => (
                <div key={`clone-${logo.id}`} className="logo-marquee__item">
                  <span>{logo.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
